import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

// Create axios instance
const api = axios.create({
    headers: {
        'Content-Type': 'application/json'
    }
});

// Add a request interceptor to include JWT token
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add a response interceptor to handle 401 errors (token expired)
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            // Auto logout if 401 response returned from api
            localStorage.removeItem('user');
            localStorage.removeItem('token');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

// Domain CRUD operations
export const getDomains = async () => {
    const response = await api.get(`${API_URL}/domains`);
    return response.data;
};

export const getDomainById = async (id) => {
    const response = await api.get(`${API_URL}/domains/${id}`);
    return response.data;
};

export const getDomainByName = async (domainName) => {
    const response = await api.get(`${API_URL}/domains/name/${domainName}`);
    return response.data;
};

export const createDomain = async (domainData) => {
    const response = await api.post(`${API_URL}/domains`, domainData);
    return response.data;
};

export const updateDomain = async (id, domainData) => {
    const response = await api.put(`${API_URL}/domains/${id}`, domainData);
    return response.data;
};

export const deleteDomain = async (id) => {
    const response = await api.delete(`${API_URL}/domains/${id}`);
    return response.data;
};

export const searchDomains = async (queryParams) => {
    // Convert query params object to URL query string
    const queryString = new URLSearchParams(queryParams).toString();
    const response = await api.get(`${API_URL}/domains/search/query?${queryString}`);
    return response.data;
};